import { createApp, h } from 'vue'
import CoreUIVuePro from '@coreui/vue-pro'
import DComponents from '~@/Configurations/DComponents'
import { createInertiaApp, Link, router } from '@inertiajs/vue3'
import AppLayout from './App.vue'
import { iconsSet as icons } from './Configurations/icons'
import route from '../../vendor/tightenco/ziggy/src/js/index.js'
import Router from '../../vendor/tightenco/ziggy/src/js//Router'
import '@mdi/font/css/materialdesignicons.min.css'
import prependPlaceholderMixin from './Mixins/prependPlaceholder'
import loadingStateMixin from './Mixins/loadingState'
import formFieldValidMixin from '~@/Mixins/formFieldValid'
import priceFormatMixin from '~@/Mixins/priceFormat'
import mitt from 'mitt'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import dateFormatMixin from '~@/Mixins/dateFormat'
import '@jsonforms/vue-vanilla/vanilla.css'

/* Application Setup */
require('./bootstrap')

const ZiggyVue = {
    install: (v, options) => v.mixin({
        methods: {
            $route: function (name, params, absolute, config = options) {
                // We append the current tenant id to all URLs generated in the backend.
                // An already existing tenant parameter has precedence over the current tenant.
                // We do the same in the backend in the RouteUrlGenerator.
                let parsedParams = params

                if (this.$page.props.tenant) {
                    // Using ziggy's router to do the parameter parsing, which emulates the laravel router.
                    const router = new Router(name, params, absolute, config)
                    parsedParams = router._params || {}

                    if (!parsedParams.tenant) {
                        parsedParams.tenant = this.$page.props.tenant
                    }
                }

                return route(name, parsedParams, absolute, config)
            }
        }
    })
}

const emitter = mitt()

createInertiaApp({
    resolve: name => {
        const page = require(`./Pages/${name}`).default
        page.layout = page.layout || AppLayout
        return page
    },
    setup ({ el, App, props, plugin }) {
        const myApp = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(CoreUIVuePro)
            .use(DComponents)
            .mixin(require('./Mixins/translation'))
            .mixin(loadingStateMixin)
            .mixin(prependPlaceholderMixin).mixin(formFieldValidMixin)
            .mixin(priceFormatMixin)
            .mixin(dateFormatMixin)
            .provide('icons', icons)
            .component('VueSelect', vSelect)
            .component('Link', Link)

        myApp.config.compilerOptions.whitespace = 'preserve'
        myApp.config.globalProperties.emitter = emitter

        window.addEventListener('unhandledrejection', function (event) {
            if (event.reason.name === 'NS_ERROR_ILLEGAL_VALUE') {
                console.info(
                    'Encountered an "NS_ERROR_ILLEGAL_VALUE". If you are using Firefox and currently load or' +
                    'display a really large amount of data from the backend, you stumbled upon a known issue.\n' +
                    'Please see: https://inertiajs.com/responses#maximum-response-size\n\n' +
                    'Either create a ticket for it or try to reduce the amount of data send by the backend.'
                )
            }
        })

        myApp.mount(el)
    },
    progress: {
        color: '#fec600',
        showSpinner: true
    }
})

// If there are any validation errors we will make first element with an error visible on the page.
// Useful for large pages, with lots of form inputs.
router.on('error', () => {
    const el = document.querySelectorAll('.error, .invalid-feedback')
    el[0]?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
})
